import { FC } from "react";

import { Radiodot } from "@repo/edtech-ui-kit";

import st from "./ClosedOptions.module.scss";

interface Props {
  questionUid: string,
  answers: string[],
  selectedOptionIndex: string | null,
  onSubmit: (value: string) => void,
}

export const ClosedOptions: FC<Props> = ({
  questionUid,
  answers,
  selectedOptionIndex,
  onSubmit,
}) => {
  return (
    <div className={st.options}>
      {
        answers.map((answer, index) => (
          <Radiodot
            key={questionUid + index}
            checked={selectedOptionIndex === index.toString()}
            label={answer}
            onChange={() => onSubmit(index.toString())}
          />
        ))
      }
    </div>
  );
};
